<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <router-view v-if="isLoaded" />
      <LoadingOverlay v-else>
        {{ $t('general.loading') }}
      </LoadingOverlay>
    </transition>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import StoreModules from './store/store-modules';
import LoadingOverlay from './components/loading/LoadingOverlay';
import PlatformMixin from './mixins/PlatformMixin';

export default {
  name: 'App',
  components: { LoadingOverlay },
  mixins: [PlatformMixin],
  async created() {
    await this.loadCurrentUser();
    await this.loadCart();
    this.dv = await this.getDeviceLocale();

    if (!this.$parse.User.current()) this.$i18n.locale = this.dv;
  },
  data() {
    return {
      dv: 'nix',
    };
  },
  computed: {
    ...mapGetters(StoreModules.USER, ['currentUser', 'isLoaded']),
  },
  methods: {
    ...mapActions(StoreModules.USER, ['loadCurrentUser']),
    ...mapActions(StoreModules.CART, ['loadCart']),
  },
};
</script>
<style lang="scss">
#app {
  font-family: 'Univers LT Roman', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-height: 100vh;
  overflow: hidden;
  -webkit-transform: translate3d(0, 0, 0);
}
</style>
